export default "__VITE_PUBLIC_ASSET__c4d88da6__"